export default __webpack_public_path__ + "static/media/ill-information.e0fa1997.svg";